import React from 'react';
import { Box } from '@mui/material';
import { useActiveVehicle } from '../../context/ActiveVehicleProvider';
import FlowStepperRenderer from './FlowStepperRenderer';

const FlowStepper: React.FC = () => {
	const { pipeline, currentIndex, stage, ticketFormMethods } =
		useActiveVehicle();

	// Hide for trivial flows — adds visual noise without informational value.
	if (pipeline.length < 3) return null;

	const ticketType = ticketFormMethods.watch('ticketType');
	const showTowBranch = ticketType === 'tow';

	return (
		<Box
			sx={{
				width: '100%',
				maxWidth: 720,
				mx: 'auto',
				px: 2,
				pb: 1,
			}}
		>
			<FlowStepperRenderer
				pipeline={pipeline}
				currentIndex={currentIndex}
				currentBranchId={stage}
				showTowBranch={showTowBranch}
			/>
		</Box>
	);
};

export default FlowStepper;
